import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { PlayerEvent } from 'src/app/shared/model/player-event';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnDestroy {

  @ViewChild('video') set video(el: ElementRef) {
    this.player = el.nativeElement;
  };

  player: HTMLVideoElement;
  source: string;

  @Input() remoteCotrolEnabled: boolean = false;
  @Input() audioEnabled: boolean = true;
  @Input() videoControl: PlayerEvent;
  @Input() set path(s: string) {
    this.source = s;
  };
  @Input() controls: boolean = false;
  @Output() pauseTime: EventEmitter<number> = new EventEmitter();
  @Output() sourceError: EventEmitter<boolean> = new EventEmitter();
  @Output() currentEvent: EventEmitter<PlayerEvent> = new EventEmitter();

  ngOnDestroy(): void {
    this.videoControl = PlayerEvent.PAUSE;
    this.source = '';
    this.player.load();
    this.player.remove();
  }
}
